import React from "react";
import { extractNumbersFromString, getWeightAdornment } from "../../extras";

// APP COMPONENTS
import OrderTicketValuesInfos from "./OrderTicketValuesInfos";
import OrderTicketGeneralInfos from "./OrderTicketGeneralInfos";
import OrderTicketDeliveryInfos from "./OrderTicketDeliveryInfos";
import OrderTicketFinancialInfos from "./OrderTicketFinancialInfos";
// MATERIAL UI COMPONENTS
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import { BoxFullHeightOnPrint, TypographyBoldOnPrint } from "../styled";
import { grey } from "@mui/material/colors";
import OrderTicketHeader from "./OrderTicketHeader";
import { useSelector } from "react-redux";
import OrderTicketBottom from "./OrderTicketBottom";
import { cnpjMask, cpfMask, formatFinance } from "../../utils/formatters";

let complement_last_label = "";
const OrderTicket = ({ order, products, changeFor, benefits }) => {
  const orderDetail = useSelector((state) => state.orders.orderDetails);

  const _order = order || orderDetail;

  if (!_order) return null;

  return (
    <BoxFullHeightOnPrint sx={{ p: 1 }}>
      <OrderTicketHeader
        channel={_order.channel}
        channelMerchant={_order.channel_merchant}
        channelOrderCode={_order.channel_order_code}
        orderType={_order.order_type}
        orderIndex={_order.order_index}
        indoorTable={_order.indoor_table}
      />
      <OrderTicketGeneralInfos
        operator={_order.operator}
        createdAt={_order.created_at}
        orderType={_order.order_type}
        customerName={_order.customer_name || _order.customer?.name}
        customerOrderCountOnRestaurant={
          _order.customer_order_count_on_restaurant
        }
        deliveryExpectedTime={_order.delivery_expected_time}
      />
      <Box>
        <TypographyBoldOnPrint
          variant="body2"
          align="center"
          fontWeight="bold"
          color={grey["900"]}
          printsize={13}
        >
          PRODUTOS
        </TypographyBoldOnPrint>
        <table>
          <thead>
            <tr className="text-left ticket--strong">
              <th>Qnt</th>
              <th className="ticket--name">Nome</th>
              <th className="ticket--price">Preço</th>
            </tr>
          </thead>
          <tbody>
            {products?.map((product, index) => {
              const label = !!(
                product.complement_categorie &&
                product.complement_categorie !== complement_last_label
              );
              complement_last_label = product.complement_categorie;

              return (
                <React.Fragment key={product.id || `product-${index}`}>
                  {label && (
                    <tr className={`ticket--${product.label}`}>
                      <td className="ticket--qnt"></td>
                      <td className="ticket--name">
                        {product.complement_categorie}
                      </td>
                      <td className="ticket--price"></td>
                    </tr>
                  )}
                  <tr className={`ticket--${product.label}`}>
                    <td className="ticket--qnt">
                      {product.level !== 2
                        ? product.unit === "KG"
                          ? `${product.quantity} ${getWeightAdornment(
                              product.unit,
                              product.quantity
                            )}`
                          : Math.floor(product.quantity)
                        : "-"}
                    </td>
                    <td
                      className="ticket--name"
                      style={{
                        paddingLeft: product.complement_categorie ? 12 : "auto",
                      }}
                    >
                      {product.title !== "undefined" ? product.title : null}
                    </td>
                    <td className="ticket--price">
                      {product.total_price
                        ? formatFinance(parseFloat(product.total_price))
                        : formatFinance(parseFloat(product.un_price ?? 0))}
                    </td>
                  </tr>
                  {product.observations ? (
                    <tr>
                      <td></td>
                      <td className="ticket--obs">
                        Obs: {product.observations}
                      </td>
                      <td></td>
                    </tr>
                  ) : null}
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
        <Divider sx={{ my: "2px" }} />
      </Box>
      <OrderTicketValuesInfos
        total={_order.total}
        sub_total={_order.sub_total}
        delivery_tax={_order.delivery_tax}
        voucher_discount={_order.voucher_discount}
        serviceFeeAmount={_order.service_fee_amount}
        tax={_order.tax}
        observations={_order.observations}
        orderType={_order.order_type}
      />
      <OrderTicketFinancialInfos
        total={_order.total}
        changeFor={changeFor}
        payment={_order.payment}
        payment_pending={_order.payment_pending}
        distance={_order.distance_to_delivery_center}
      />
      <OrderTicketDeliveryInfos
        channel={_order.channel}
        order_type={_order.order_type}
        address={_order.address}
        delivery_obs={_order.delivery_obs}
        order_contact={_order.order_contact}
        delivery_pickup_code={_order.delivery_pickup_code}
      />
      {_order.customer?.cpf && (
        <Box>
          <TypographyBoldOnPrint
            variant="body2"
            align="center"
            color={grey["900"]}
            gutterBottom
          >
            Incluir dados fiscais
          </TypographyBoldOnPrint>
          {extractNumbersFromString(_order.customer.cpf).length < 14 ? (
            <TypographyBoldOnPrint
              variant="body2"
              align="center"
              color={grey["900"]}
              gutterBottom
            >
              {cpfMask(extractNumbersFromString(_order.customer.cpf))}
            </TypographyBoldOnPrint>
          ) : (
            <TypographyBoldOnPrint
              variant="body2"
              align="center"
              color={grey["900"]}
              gutterBottom
            >
              {cnpjMask(extractNumbersFromString(_order.customer.cpf))}
            </TypographyBoldOnPrint>
          )}
          <Divider sx={{ mb: 1 }} />
        </Box>
      )}

      <OrderTicketBottom
        orderType={_order.order_type}
        orderIndex={_order.order_index}
        indoorTable={_order.indoor_table}
        changeFor={changeFor}
      />
    </BoxFullHeightOnPrint>
  );
};

export default OrderTicket;
